import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import { useParams } from "react-router-dom";
import { BsPersonFill } from "react-icons/bs";
import ConfirmationModal from "../../components/AdminApproval/ConfirmationModal"; // Import the modal component

function AdminBrandView() {
  const { id } = useParams();
  const [brandData, setBrandData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [actionType, setActionType] = useState("");

  // Fetch brand data on component mount
  useEffect(() => {
    const fetchBrandData = async () => {
      try {
        const response = await USER_URL.get(`/products/admin/brands/${id}/`);
        console.log("BRand view",response.data.Data);
        
        if (response.data?.Data) {
          setBrandData(response.data.Data);
        }
      } catch (error) {
        console.error("Error fetching brand data:", error.message || error);
      }
    };
    fetchBrandData();
  }, [id]);

  // Open the confirmation modal
  const openModal = (action) => {
    setActionType(action);
    setModalOpen(true);
  };

  // Handle brand status update
  const handleConfirm = async () => {
    try {
      const newStatus = actionType === "Approve" ? "Approved" : "Rejected";
      await USER_URL.post(`/products/admin/brands/${id}/`, {
        status: newStatus,
      });

      // Update the UI immediately after API call
      setBrandData((prevData) => ({
        ...prevData,
        status: newStatus,
      }));
    } catch (error) {
      console.error("Error updating status:", error.message || error);
    } finally {
      setModalOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="flex items-center space-x-6 mb-8">
        {/* Profile Avatar */}
        <div className="w-24 h-24 bg-yellow-300 rounded-full border border-gray-300 flex items-center justify-center cursor-pointer">
          <BsPersonFill className="text-gray-500 size-20" />
        </div>
        {/* Logo */}
        <div className="w-24 h-24 shadow-md flex items-center justify-center border-2 border-gray-300 rounded-lg">
          <img
            src={
              brandData.logo instanceof File
                ? URL.createObjectURL(brandData.logo)
                : `${BASE_URL}${brandData.logo}`
            }
            alt={brandData.name}
            className="w-full h-full object-contain rounded-lg"
          />
        </div>
      </div>

      {/* Personal & Company Info */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        {/* Personal Info */}
        <div>
          <h2 className="text-2xl font-bold mb-4">Personal Info</h2>
          <div className="space-y-4">
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">
                Name
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {brandData.name || "John Doe"}
              </p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">
                Email
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {brandData.email || "john.doe@example.com"}
              </p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">
                Phone Number
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {brandData.phone || "+1 234 567 890"}
              </p>
            </div>
          </div>
        </div>

        {/* Company Info */}
        <div>
          <h2 className="text-2xl font-bold mb-4">Company Info</h2>
          <div className="space-y-4">
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">
                Company Name
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {brandData.company_name || "no company name"}
              </p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">
                Company Location
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {brandData.location || "no location"}
              </p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">
                Company Email
              </span>
              <p className="text-lg font-semibold text-gray-800">
                {brandData.companyEmail || "no email"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Brand Name & Logo */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        <div>
          <h2 className="text-2xl font-bold mb-4">Brand Name</h2>
          <div className="p-4 bg-white border rounded-lg shadow-sm">
            <p className="text-lg font-semibold text-gray-800">
              {brandData.brandname || "No brand"}
            </p>
          </div>
          {/* Brand Logo */}
          <div className="w-24 h-24 mt-4 shadow-md flex items-center justify-center border-2 border-gray-300 rounded-lg">
            <img
              src={
                brandData.image instanceof File
                  ? URL.createObjectURL(brandData.image)
                  : `${BASE_URL}${brandData.image}`
              }
              alt="Brand Logo"
              className="w-full h-full object-contain rounded-lg"
            />
          </div>
        </div>

        {/* Banner Image */}
        <div>
          <h2 className="text-2xl font-bold mb-4">Banner Image</h2>
          <div className="w-full h-32 bg-gray-100 border-2 border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-lg">
            {brandData.brand_banner ? (
              <img
                src={
                  brandData.brand_banner instanceof File
                    ? URL.createObjectURL(brandData.brand_banner)
                    : `${BASE_URL}${brandData.brand_banner}`
                }
                alt="Banner"
                className="w-full h-full object-cover rounded-lg"
              />
            ) : (
              "Images"
            )}
          </div>
          <div className="flex justify-between mt-5">
            <button
              onClick={() => openModal("Approve")}
              className="border rounded-lg px-4 py-2 text-sm font-medium w-[200px] text-green-600 border-green-600 hover:bg-green-100"
            >
              Approve
            </button>
            <button
              onClick={() => openModal("Reject")}
              className="border rounded-lg px-4 py-2 text-sm font-medium w-[200px] text-red-600 border-red-600 hover:bg-red-100"
            >
              Reject
            </button>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
        action={actionType}
        product={brandData}
      />
    </div>
  );
}

export default AdminBrandView;
